import { FetchPolicy, graphql, useLazyLoadQuery } from "react-relay"
import { useChMedicationDetailByIdQuery as useChMedicationDetailByIdQueryType } from "@/modules/patients/detail/medication/ch/services/__generated__/useChMedicationDetailByIdQuery.graphql"

const query = graphql`
  query useChMedicationDetailByIdQuery($id: ID!, $skip: Boolean!) {
    ch_medicationDetailById(id: $id) @skip(if: $skip) {
      ... on ch_SuccessMedicationDetailResult {
        result {
          id
          canDelete
        }
      }
    }
  }
`

type useChMedicationDetailByIdQueryProps = {
  id: string
  fetchPolicy?: FetchPolicy
}

const useChMedicationDetailByIdQuery = ({ id, fetchPolicy }: useChMedicationDetailByIdQueryProps) => {
  const { ch_medicationDetailById } = useLazyLoadQuery<useChMedicationDetailByIdQueryType>(
    query,
    {
      id,
      skip: !id || id.length === 0,
    },
    {
      fetchPolicy,
    },
  )

  return ch_medicationDetailById
}

export { useChMedicationDetailByIdQuery }
